import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;

  & > div {
    width: 70px;

    p {
      margin: 2px 0 0;
    }

    p:first-of-type {
      font-size: 12px;
      line-height: 16px;
    }

    p:last-of-type {
      font-size: 16px;
      line-height: 16px;
      font-weight: 500;
    }
  }
`;
